import React, { Children, cloneElement, isValidElement } from 'react'
import { UseFormMethods } from 'react-hook-form'
import CSS from 'csstype'

const FormItem: React.FC<FormItemProps> = ({
  children,
  name,
  defaultValue,
  register,
  form,
  rules,
  classes,
  style,
  errors,
  alreadySubmitted = false,
}) => {
  // console.log("Errores", errors)
  const getPath = (obj, name) => {
    // console.log("name", name)
    // console.log("obj", obj)
    return name.split('.').reduce((o, path) => (o || {})[path], obj) // Oliver Steel Nested Access Pattern
  }
  // Se mapean todos los child, para inyectarles las props del parent que son recibidas del Form Wrapper
  const childrenWithProps = Children.map(children, (child) => {
    // isValidElement es utilizado para evadir errores de typescript
    if (isValidElement(child))
      return cloneElement(child as React.ReactElement<any>, {
        name,
        defaultValue,
        register,
        rules,
        error: errors && getPath(errors, name),
        form,
        alreadySubmitted,
      } as any)
    return child
  })

  getPath(errors, name)
  return (
    <div className={`mx-1 ${classes}`} style={style}>
      {childrenWithProps}
      {errors && getPath(errors, name) && (
        <p className="text-danger dark:text-danger-dark">
          {getPath(errors, name).message}
        </p>
      )}
    </div>
  )
}

export default FormItem

interface FormItemProps {
  children: React.ReactNode
  name: string
  defaultValue?: any
  register?: any
  rules?: object
  errors?: object
  form?: UseFormMethods<any>
  classes?: string
  style?: CSS.Properties
  alreadySubmitted?: boolean
}
